import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { Clock, CheckCircle } from "lucide-react";

interface Interaction {
  id: string;
  consumerName: string;
  callPurposeDisplay: string;
  callTime: string;
  callStatusDisplay: string;
}

interface RecentInteractionsProps {
  interactions: Interaction[];
}

export function RecentInteractions({ interactions }: RecentInteractionsProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Clock className="h-5 w-5 text-primary" />
          Recent Customer Interactions
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3 mt-4">
          {interactions?.map((interaction) => (
            <div
              key={interaction.id}
              className="flex items-center justify-between p-3 rounded-lg bg-muted/50"
            >
              <div>
                <p className="font-medium text-foreground">
                  {interaction.consumerName}
                </p>
                <p className="text-sm text-muted-foreground">
                  {interaction.callPurposeDisplay}
                </p>
              </div>
              <div className="text-right">
                <p className="text-sm text-muted-foreground">
                  {interaction.callTime}
                </p>
                <div className="flex items-center gap-1">
                  {interaction.callStatusDisplay === "resolved" && (
                    <CheckCircle className="h-3 w-3 text-success" />
                  )}
                  <span
                    className={`text-xs px-2 py-1 rounded-full ${
                      interaction.callStatusDisplay === "resolved"
                        ? "bg-success/10 text-success"
                        : interaction.callStatusDisplay === "pending"
                        ? "bg-warning/10 text-warning"
                        : "bg-info/10 text-info"
                    }`}
                  >
                    {interaction.callStatusDisplay}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
        {/* <Button variant="outline" className="w-full mt-4">
          View All Interactions
        </Button> */}
      </CardContent>
    </Card>
  );
}
